const objectToString = (items, key) => {
  return items.map(function (item) {
    return item[key || 'tag']
  })
}

export default objectToString
